<template>
  <LayoutCollection
    v-bind="$props"
    class="partners"
  >
    <template #item="{ item }">
      <UiMediaImage
        :image="item.logo"
        :options="{ fit: 'contain', background: '#FFFFFF' }"
        :quality="35"
        width="130"
        ratio="1"
        contain
        class="partners__item"
      />
    </template>
  </LayoutCollection>
</template>

<style lang="stylus" scoped>
$partner-breakpoint = L
.partners__item {
  width 70px
  height 70px
  box-sizing content-box
  padding 15px 30px

  +size($partner-breakpoint) {
    width 130px
    height 130px
    padding 30px 60px
  }
}

:deep(.grid-layout__items) {
  display flex
  flex-wrap wrap
  justify-content center
  border-top 1px solid $cl-separator
  border-bottom @border-top
}

:deep(.grid-layout__item) {
  width auto
  line-height 0

  +size($partner-breakpoint) {
    border-left 1px solid $cl-separator
    border-right @border-left
    border-bottom @border-left
    margin-right -1px
    margin-bottom -1px
  }
}
</style>